"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var splice = function splice() {
  var array = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
  var index = arguments[1];
  var removeNum = arguments[2];
  var value = arguments[3];

  var copy = [].concat(_toConsumableArray(array));
  if (removeNum) {
    copy.splice(index, removeNum); // removing
  } else {
      if (index < copy.length) {
        copy.splice(index, 0, value); // adding
      } else {
          copy[index] = value; // outside range, so just set it
        }
    }
  return copy;
};

exports.default = splice;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/structure/plain/splice.js
// module id = 1222
// module chunks = 0